export function copyLinkToBuffer() {
    let link = $('.copy-link');
    let url = $(location).attr('href');
    let temp = $("<input>");

    link.on('click', function (e) {
        e.preventDefault();
        link.addClass('clicked');
        $("body").append(temp);
        temp.val(url).select();
        document.execCommand("copy");
        temp.remove();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/copyLinkToBuffer.js